// Font Size Monitor Script mit default-font-size Berechnung
(function() {
    let initialFontSize = null;
    
    // Funktion zum Extrahieren der Font-Size aus dem Style-Attribut
    function getFontSizeFromElement(element) {
        const style = element.getAttribute('style') || '';
        const fontSizeMatch = style.match(/font-size:\s*(\d+(?:\.\d+)?)px/);
        return fontSizeMatch ? parseFloat(fontSizeMatch[1]) : null;
    }
    
    // Funktion zum Setzen des Wertes im Input-Feld
    function updateTextSizeDefault(value) {
        const inputField = document.getElementById('text-size-default');
        if (inputField) {
            inputField.value = Math.floor(value) + 'px';
            console.log('Text-size-default updated to:', Math.floor(value) + 'px');
        }
    }
    
    // Funktion zum Berechnen und Setzen der default-font-size Attribute
    function calculateAndSetDefaultFontSizes(baseFontSize) {
        const radioButtons = document.querySelectorAll('input[name="properties[Schriftart]"]');
        
        radioButtons.forEach(radio => {
            const fontSizeAttr = parseFloat(radio.getAttribute('font-size'));
            if (fontSizeAttr && baseFontSize) {
                const calculatedSize = baseFontSize * fontSizeAttr;
                radio.setAttribute('default-font-size', calculatedSize.toFixed(2));
                console.log(`${radio.value}: ${baseFontSize}px × ${fontSizeAttr} = ${calculatedSize.toFixed(2)}px`);
            }
        });
    }
    
    // Funktion zum Abrufen des default-font-size Wertes vom aktiven Radio Button
    function getActiveRadioDefaultSize() {
        const activeRadio = document.querySelector('input[name="properties[Schriftart]"]:checked');
        if (activeRadio) {
            const defaultSize = parseFloat(activeRadio.getAttribute('default-font-size'));
            return isNaN(defaultSize) ? initialFontSize : defaultSize;
        }
        return initialFontSize;
    }
    
    // Initialisierung beim Seitenladen
    function initialize() {
        const textPreview = document.getElementById('text-preview-3');
        if (textPreview) {
            initialFontSize = getFontSizeFromElement(textPreview);
            console.log('Initial font size detected:', initialFontSize + 'px');
            
            // Berechne und setze default-font-size für alle Radio Buttons
            calculateAndSetDefaultFontSizes(initialFontSize);
            
            // Setze den Anfangswert ins Input-Feld
            updateTextSizeDefault(initialFontSize);
        } else {
            console.error('Element #text-preview-3 not found');
        }
    }
    
    // Event Listener für Radio Button Änderungen (Schriftart)
    function setupSchriftartListeners() {
        const radioButtons = document.querySelectorAll('input[name="properties[Schriftart]"]');
        
        radioButtons.forEach(radio => {
            radio.addEventListener('change', function() {
                if (this.checked) {
                    console.log('Schriftart changed to:', this.value);
                    
                    const defaultSize = parseFloat(this.getAttribute('default-font-size'));
                    if (!isNaN(defaultSize)) {
                        updateTextSizeDefault(defaultSize);
                        console.log(`Using default-font-size: ${defaultSize}px for ${this.value}`);
                    }
                }
            });
        });
    }
    
    // Event Listener für Radio Button Änderungen (Schriftfarbe) - falls diese auch die Font-Size beeinflussen
    function setupSchriftfarbenListeners() {
        const radioButtons = document.querySelectorAll('input[name="properties[Schriftfarbe]"]');
        
        radioButtons.forEach(radio => {
            radio.addEventListener('change', function() {
                if (this.checked) {
                    console.log('Schriftfarbe changed to:', this.value);
                    
                    // Kurze Verzögerung, falls sich die Font-Size durch den Radio Button ändert
                    setTimeout(() => {
                        const activeSize = getActiveRadioDefaultSize();
                        updateTextSizeDefault(activeSize);
                    }, 100);
                }
            });
        });
    }
    
    // MutationObserver für Änderungen am style-Attribut von #text-preview-3
    function setupMutationObserver() {
        const textPreview = document.getElementById('text-preview-3');
        if (!textPreview) return;
        
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    // Bei Style-Änderungen den aktiven Radio Button Wert verwenden
                    const activeSize = getActiveRadioDefaultSize();
                    updateTextSizeDefault(activeSize);
                    console.log(`Style changed: Using active radio default-font-size: ${activeSize}px`);
                }
            });
        });
        
        observer.observe(textPreview, {
            attributes: true,
            attributeFilter: ['style']
        });
        
        console.log('MutationObserver setup for #text-preview-3');
    }
    
    // Script starten
    function start() {
        // Warten bis DOM geladen ist
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                initialize();
                setupSchriftartListeners();
                setupSchriftfarbenListeners();
                setupMutationObserver();
            });
        } else {
            initialize();
            setupSchriftartListeners();
            setupSchriftfarbenListeners();
            setupMutationObserver();
        }
    }
    
    // Script ausführen
    start();
    
})();